<!-- <ng-template [ngIf]="isLoading">
  <app-loading-page></app-loading-page>
</ng-template> -->
<!-- <ng-template [ngIf]="!isLoading"> -->
<!--TODO: Fix isLoading masking-->
<router-outlet></router-outlet>
